import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// routes
import { getPathAfterLogin } from '../config';
import { getSessionOperator } from "../helper/session";
// components
import LoadingScreen from '../components/loading-screen';

//
import {useAuthContext} from "./useAuthContext";
import {isPrimaryUser} from "./FirebaseContext";

GuestGuard.propTypes = {
    children: PropTypes.node,
};

export default function GuestGuard({ children }) {
    const { isAuthenticated, isInitialized } = useAuthContext();

    if (isAuthenticated) {
        return <Navigate to={getPathAfterLogin(getSessionOperator(), isPrimaryUser())} />;
    }

    if (!isInitialized) {
        return <LoadingScreen />;
    }

    return <>{children}</>;
}
